import { render, staticRenderFns } from "./contract-formation.vue?vue&type=template&id=bf490af8"
import script from "./contract-formation.vue?vue&type=script&lang=ts"
export * from "./contract-formation.vue?vue&type=script&lang=ts"
import style0 from "./contract-formation.vue?vue&type=style&index=0&id=bf490af8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports